import { render } from "./PortfolioIllustration.vue?vue&type=template&id=961d7e0e&scoped=true"
import script from "./PortfolioIllustration.vue?vue&type=script&lang=js"
export * from "./PortfolioIllustration.vue?vue&type=script&lang=js"

import "./PortfolioIllustration.vue?vue&type=style&index=0&id=961d7e0e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-961d7e0e"]])

export default __exports__